<div class="rdc-wrap">
    <div class="rdc-table-container">
        <table class="rdc-table">
            <thead>
                <tr>
                    <th>Contract ID</th>
                    <th>Status</th>
                    <th>Opened At</th>
                </tr>
            </thead>
            <tbody>
                @for (row of pagedContracts; track $index) {
                <tr>
                    <td>{{ row.contractId || '---' }}</td>
                    <td>{{ row.status.split('_').join(' ') | capitalize }}</td>
                    <td>
                        <span class="rdc-date-main">{{ (row.openedAt | date:'MM/dd/yyyy') || '---' }}</span>
                        <span class="rdc-date-sub">{{ row.openedAt | date:'hh:mm:ss a' }}</span>
                    </td>
                </tr>
                } @empty {
                <tr>
                    <td colspan="3" class="rdc-empty">No contracts found</td>
                </tr>
                }
            </tbody>
        </table>
    </div>

    @if (totalRecords > 0) {
    <div class="table-footer">
        <span class="footer-count">Showing {{ first + pagedContracts.length }} of {{ totalRecords }}</span>
        <p-paginator [first]="first" [rows]="rows" [totalRecords]="totalRecords"
            [rowsPerPageOptions]="[20, 30, 50]" [dropdownAppendTo]="'body'"
            (onPageChange)="onPageChange($event)" />
    </div>
    }
</div>
